import React from "react";

import { menuCategoryService } from "@/services/MenuService";

import toast from "../toast";

interface AddCategoryModalProps {
  onClose: () => void;
  onSubmit: (data: any) => void;
  open: boolean;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  onClose,
  onSubmit,
  open,
}) => {
  const [form, setForm] = React.useState({
    description: "",
    name: "",
  });
  const [loading, setLoading] = React.useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await menuCategoryService.addCategory(form);
      toast.success("Category added successfully!");
      onSubmit(res.data); // Pass new category data to parent
      onClose();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to add category.");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <form
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <h2 className="mb-4 text-xl font-bold text-gray-900 dark:text-gray-100">
          Add Category
        </h2>
        <div className="space-y-2">
          <input
            className="mb-2 w-full rounded border px-2 py-1 dark:bg-gray-800 dark:text-gray-100"
            disabled={loading}
            name="name"
            onChange={handleChange}
            placeholder="Name"
            required
            value={form.name}
          />
          <input
            className="mb-2 w-full rounded border px-2 py-1 dark:bg-gray-800 dark:text-gray-100"
            disabled={loading}
            name="description"
            onChange={handleChange}
            placeholder="Description"
            value={form.description}
          />
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            className="rounded bg-gray-400 px-4 py-2 text-white"
            disabled={loading}
            onClick={onClose}
            type="button"
          >
            Cancel
          </button>
          <button
            className="rounded bg-blue-600 px-4 py-2 text-white"
            disabled={loading}
            type="submit"
          >
            {loading ? "Adding..." : "Add"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCategoryModal;
